module.exports = __webpack_public_path__ + "img/premium-img-1.4a2057d6.png";